import { Form, Table, Typography } from 'antd';
import {
  QuotationsOffersPublicFormValues,
  QuotationsOffersPublicItemsList,
} from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.types';
import { getTableScrollX } from '@/utils/table';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { InputDecimal } from '@/components/_common';
import ManufacturerInfiniteSelectFieldPublic from '@/components/_common/ManufacturerInfiniteSelectFieldPublic';

interface Props {
  dataItems?: QuotationsOffersPublicItemsList[];
  matrixId?: number;
}

const QuotationRequestItemsList: React.FC<Props> = ({
  dataItems,
  matrixId,
}) => {
  const form = Form.useFormInstance<QuotationsOffersPublicFormValues>();

  const items = Form.useWatch('items', form);

  const handleValueTotal = (indexItem: number) => {
    if (items?.length) {
      return items
        .filter((_, index) => index === indexItem)
        .reduce(
          (acc, curr) =>
            (acc +=
              (((curr.quantity ?? 0) * (curr.unitCost ?? 0)) / 100) *
              (100 - (curr.discount ?? 0))),
          0,
        );
    }

    return 0;
  };

  const columns: ColumnsType<QuotationsOffersPublicItemsList> = [
    {
      key: 'code',
      dataIndex: 'code',
      title: 'Código',
      ellipsis: true,
      width: 180,
    },
    {
      key: 'description',
      dataIndex: 'description',
      title: 'Descrição',
      ellipsis: true,
      width: 220,
    },
    {
      key: 'manufacturerId',
      dataIndex: 'manufacturerId',
      title: 'Fabricante',
      render: (value, _, i) => {
        return (
          <Form.Item name={[i, 'manufacturerId']} noStyle>
            <ManufacturerInfiniteSelectFieldPublic queryFilter={{ matrixId }} />
          </Form.Item>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      key: 'quantity',
      dataIndex: 'quantity',
      title: 'Quantidade',
      render: (_, row, i) => {
        return (
          <Form.Item name={[i, 'quantity']} noStyle>
            <InputDecimal value={row.quantity} max={row.quantity} min={0.01} />
          </Form.Item>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      key: 'deliverDays',
      dataIndex: 'deliverDays',
      title: 'Entrega(Dias)',
      render: (_, __, i) => {
        return (
          <Form.Item name={[i, 'deliverDays']} noStyle>
            <InputDecimal fractions={0} />
          </Form.Item>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      key: 'unitCost',
      dataIndex: 'unitCost',
      title: 'Valor unit.',
      render: (value, __, i) => {
        return (
          <Form.Item name={[i, 'unitCost']} noStyle>
            <InputDecimal value={value} />
          </Form.Item>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      key: 'discount',
      dataIndex: 'discount',
      title: '%Desc.',
      render: (value, __, i) => {
        return (
          <Form.Item name={[i, 'discount']} noStyle>
            <InputDecimal value={value} />
          </Form.Item>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      key: 'valueTotal',
      dataIndex: 'valueTotal',
      title: 'Total',
      render: (_, __, i) => {
        return <InputDecimal disabled value={handleValueTotal(i)} />;
      },
      ellipsis: true,
      align: 'right',
      width: 140,
    },
  ];

  return (
    <Form.List name="items">
      {() => (
        <Table
          columns={columns}
          dataSource={dataItems}
          rowKey={(row) => row.id}
          scroll={{ x: getTableScrollX(columns) }}
          pagination={false}
          title={() => <Typography.Title level={4}>Itens</Typography.Title>}
        />
      )}
    </Form.List>
  );
};

export default QuotationRequestItemsList;
